import React, { useState } from "react";
import Header from "../Header/Header";
import { useMediaQuery } from "react-responsive";
import OutlinedCard from "../Card/mobCard";
import "./HomePage.css";

function EodReports() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 1024px)" });

  const handleIframeLoad = () => {
    setLoading(false);
    setError(false); // Reset error state on successful load
  };

  const handleIframeError = () => {
    setLoading(false);
    setError(true);
  };

  return (
    <>
      {isDesktopOrLaptop ? (
        <div className="App">
          <div style={{ zIndex: 1000, position: "sticky", top: 0 }}>
            <Header />
          </div>
          <div className="iframe-container">
            {loading && !error && <div className="loader">Loading...</div>}
            {error && <div className="error-message">Failed to load content. Please try again later.</div>}
            <iframe
              src="https://www.dartstech.com/widgets/eod-reports.aspx?custid=27"
              title="Eod Report"
              frameBorder="0"
              allowFullScreen
              onLoad={handleIframeLoad}
              onError={handleIframeError}
              style={{ display: loading || error ? "none" : "block" }}
            ></iframe>
          </div>
        </div>
      ) : (
        <OutlinedCard />
      )}
    </>
  );
}

export default EodReports;
